import { usePatchAgency } from '../data/usePatchAgency';

export type ChangeAgencyPayload = {
  agencyExternalId: string;
  agencyName: string;
  institutionSupport?: boolean;
};

export function useChangeAgency(applicationId: string) {
  const { patchAgency, isPatchingAgency } = usePatchAgency(applicationId);

  async function changeAgency(payload: ChangeAgencyPayload) {
    return await patchAgency(payload);
  }

  return {
    changeAgency,
    isPatchingAgency,
  };
}
